export const pagesTimeAndAttendanceEn = {
  attendanceLinks: {
    description: 'The store attendance manager will have part-time employees manage their daily attendance.',
    form: {
      buttons: {
        cancel: 'Cancel',
        delete: 'Delete',
        deleting: 'Deleting...',
        print: 'Print',
        publish: 'Publish',
        publishing: 'Publishing...',
        replace: 'Replace Link',
        replacing: 'Replacing...',
        save: 'Save',
        saving: 'Saving...'
      },
      deleteDialog: {
        cancelButton: 'Cancel',
        deleteButton: 'Delete',
        description: 'The attendance link will be permanently removed. This action cannot be undone.',
        title: 'Are you sure you want to delete?'
      },
      frequency: 'Frequency',
      invalid: '(Expired)',
      messages: {
        error: {
          default: 'An error occurred',
          delete: 'Failed to delete link',
          publish: 'Failed to publish attendance link',
          replace: 'Failed to replace attendance link',
          update: 'Failed to update attendance link',
          validation: 'Validation error'
        },
        success: {
          deleted: 'Link deleted successfully',
          published: 'Attendance link published successfully',
          replaced: 'Attendance link replaced successfully',
          updated: 'Attendance link updated successfully'
        }
      },
      notice: 'Notice',
      noticePlaceholder: 'Enter notice text here...',
      options: {
        daily: 'Daily',
        weekly: 'Weekly'
      },
      replaceDialog: {
        cancelButton: 'Cancel',
        description: 'The link URL will be changed. This action cannot be undone.',
        replaceButton: 'Replace',
        title: 'Are you sure you want to replace?'
      },
      validityPeriod: 'Validity Period',
      validityPeriodPlaceholder: 'Select...'
    },
    pageTitle: 'Attendance Links',
    place: 'Place',
    qrCode: {
      pdf: 'PDF',
      printTimestampSheet: 'Print QR timestamps sheet'
    },
    redirect: {
      noLocation: 'No attendance location found',
      redirecting: 'Redirecting to attendance page...'
    },
    title: 'Clocking In/Out – {{placeName}}'
  },
  attendances: {
    dailyPlace: {
      closeAttendance: 'Close Attendance',
      pageTitle: 'Attendances',
      searchPlaceholder: 'Search by member name'
    },
    editReason: 'Reason',
    editedRecord: 'Edited Record',
    monthlyPerson: {
      pageTitle: 'Attendances',
      summary: {
        daysErrored: 'Days errored',
        daysUnit: 'days',
        daysWorked: 'Days worked',
        totalHours: 'Total hours'
      }
    },
    monthlyPlace: {
      pageTitle: 'Attendances',
      searchPlaceholder: 'Search by member name',
      summary: {
        daysUnit: 'days',
        errorDayCount: 'Error days',
        errorWorkerCount: 'Error workers',
        workersUnit: 'workers'
      }
    },
    summaryUnit: {
      daily: 'Day',
      monthly: 'Month'
    },
    timeFormat: {
      hourUnit: 'h',
      minuteUnit: 'm'
    },
    toCurrentDate: 'To current date',
    toCurrentMonth: 'To current month',
    updateDialog: {
      breakTime: 'Break Time',
      clockInTime: 'Clock In',
      clockOutTime: 'Clock Out',
      currentTime: 'Current Time',
      personName: 'Person Name',
      reason: 'Reason',
      reasonPlaceholder: 'Reason',
      save: 'Save',
      updateBreakTime: 'Update Break Time',
      updateBreakTimeSuccess: 'Break time updated successfully',
      updateClockIn: 'Update Clock In',
      updateClockInSuccess: 'Clock in updated successfully',
      updateClockOut: 'Update Clock Out',
      updateClockOutSuccess: 'Clock out updated successfully',
      validation: {
        invalidTimeFormat: 'Invalid time format',
        overTimeLimit: 'Time over 28:00 is not allowed',
        startTimeMustBeBeforeEndTime: 'Start time must be before end time'
      }
    }
  },
  pageTitle: 'Time & Attendance',
  tabs: {
    attendanceLinks: 'Attendance Settings',
    attendances: 'Attendances'
  }
};